{
  const SEL_PREV = '[data-load-more-prev]';
  const SEL_NEXT = '[data-load-more-next]';
  const SEL_CURRENT = '[data-load-more-current]';

  class PaginationLoadMore extends HTMLElement {
    constructor() {
      super();
      this.gridSelector = this.dataset.productsTarget || '#CollectionLoop';
      this.position = this.dataset.position || 'bottom';
      this.handlePrev = () => this.load('prev');
      this.handleNext = () => this.load('next');
    }

    connectedCallback() {
      this.grid = document.querySelector(this.gridSelector);
      if (!this.grid) return;
      const prevBtn = this.querySelector(SEL_PREV);
      const nextBtn = this.querySelector(SEL_NEXT);
      if (prevBtn) prevBtn.addEventListener('click', this.handlePrev);
      if (nextBtn) nextBtn.addEventListener('click', this.handleNext);
    }

    disconnectedCallback() {
      const prevBtn = this.querySelector(SEL_PREV);
      const nextBtn = this.querySelector(SEL_NEXT);
      if (prevBtn) prevBtn.removeEventListener('click', this.handlePrev);
      if (nextBtn) nextBtn.removeEventListener('click', this.handleNext);
    }

    async load(direction) {
      if (PaginationLoadMore.isLoading) return;
      const btn = this.querySelector(direction === 'prev' ? SEL_PREV : SEL_NEXT);
      const url = btn && btn.dataset.url;
      if (!url) return;

      PaginationLoadMore.setLoadingState(true, btn);

      try {
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.querySelector(this.gridSelector);
        if (!newGrid) throw new Error('Grid not found in response');

        /* Replace grid content — bounded DOM, no accumulation */
        this.grid.innerHTML = newGrid.innerHTML;

        /* Sync every pagination-load-more instance on the page (top + bottom) */
        PaginationLoadMore.syncAllInstances(doc);

        /* Push state for shareable URL */
        try { history.pushState({}, '', url); } catch (e) {}

        /* Scroll to top of grid */
        const gridTop = this.grid.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: gridTop, behavior: 'smooth' });

        this.dispatchEvent(new CustomEvent('pagination:loaded', {
          bubbles: true,
          detail: { url, direction },
        }));
      } catch (err) {
        console.error('[pagination-load-more]', err);
        window.location.href = url;
      } finally {
        PaginationLoadMore.setLoadingState(false, btn);
      }
    }

    /* Re-bind handlers AND copy fresh state into every pagination-load-more
       instance on the current page using the freshly-fetched document. */
    static syncAllInstances(doc) {
      document.querySelectorAll('pagination-load-more').forEach((inst) => {
        const newInst = doc.querySelector(
          'pagination-load-more[data-position="' + inst.dataset.position + '"]'
        );
        if (!newInst) {
          /* Position didn't render on the new page (e.g. no previous on page 1) */
          inst.innerHTML = '';
          return;
        }
        inst.innerHTML = newInst.innerHTML;
        /* Re-bind click listeners on the freshly-replaced buttons */
        const prevBtn = inst.querySelector(SEL_PREV);
        const nextBtn = inst.querySelector(SEL_NEXT);
        if (prevBtn) prevBtn.addEventListener('click', () => inst.load('prev'));
        if (nextBtn) nextBtn.addEventListener('click', () => inst.load('next'));
      });
    }

    static setLoadingState(loading, btn) {
      PaginationLoadMore.isLoading = loading;
      /* CSS handles the text/loading swap via [disabled] selector */
      document.querySelectorAll('[data-load-more-prev], [data-load-more-next]').forEach((b) => {
        b.disabled = loading;
      });
    }
  }

  PaginationLoadMore.isLoading = false;

  if (!customElements.get('pagination-load-more')) {
    customElements.define('pagination-load-more', PaginationLoadMore);
  }
}
